const applyAttributesToElement = (element, attributes) => {
  Object.entries(attributes).forEach(([name, value]) => {
    try {
      if (value === true || value === '') {
        element.setAttribute(name, '');
      } else if (value) {
        element.setAttribute(name, value);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(`Failed to set attribute "${name}":`, error);
    }
  });
};

export default applyAttributesToElement;
